import React from "react";
import { CollapsibleFormSection } from "../../common/CollapsibleFormSection";
import { FormCheckboxGroup } from "../../common/FormCheckboxGroup";
import { FormTextarea } from "../../common/FormTextarea";
import { PersonalisedLearningSupportPlanData } from "src/models/form-types";

interface AdditionalInfoSectionProps {
  formData: PersonalisedLearningSupportPlanData;
  onTextChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => void;
  onCheckboxChange: (
    name: string,
    checked: boolean,
    category: keyof PersonalisedLearningSupportPlanData
  ) => void;
  className?: string;
}

// Define the additional info options
const additionalInfoOptions = [
  {
    id: "info-medication",
    name: "Currently taking prescribed medication",
    label: "Currently taking prescribed medication",
  },
  {
    id: "info-allied",
    name: "Receives Allied Health support (e.g., occupational or speech therapy)",
    label:
      "Receives Allied Health support (e.g., occupational or speech therapy)",
  },
  {
    id: "info-external",
    name: "Receives external support from a psychologist or paediatrician",
    label: "Receives external support from a psychologist or paediatrician",
  },
  {
    id: "info-none",
    name: "None",
    label: "None",
  },
];

export const AdditionalInfoSection: React.FC<AdditionalInfoSectionProps> = ({
  formData,
  onTextChange,
  onCheckboxChange,
  className,
}) => {
  // Handle checkbox changes
  const handleAdditionalInfoChange = (name: string, checked: boolean) => {
    // If selecting None, clear others; if selecting others, uncheck None
    if (name === "None") {
      if (checked) {
        // Uncheck all existing selections first
        formData.additionalInfo.forEach((opt) => {
          if (opt !== "None") onCheckboxChange(opt, false, "additionalInfo");
        });
        onCheckboxChange("None", true, "additionalInfo");
      } else {
        onCheckboxChange("None", false, "additionalInfo");
      }
      return;
    }

    // Selecting any non-None option should uncheck None
    if (checked && formData.additionalInfo.includes("None")) {
      onCheckboxChange("None", false, "additionalInfo");
    }
    onCheckboxChange(name, checked, "additionalInfo");
  };

  return (
    <CollapsibleFormSection title="Additional Notes" className={className}>
      <p className="form-description">
        You might like to include circumstances and background, support
        networks, or other information from the school, parent or carer.
      </p>

      <FormCheckboxGroup
        options={additionalInfoOptions}
        selectedValues={formData.additionalInfo}
        onChange={handleAdditionalInfoChange}
        columns={2}
      />

      <FormTextarea
        id="otherAdditionalInfo"
        name="otherAdditionalInfo"
        label="Other:"
        value={formData.otherAdditionalInfo}
        onChange={onTextChange}
        rows={2}
      />
    </CollapsibleFormSection>
  );
};
